import script from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true"
export * from "./transportSwitch.vue?vue&type=script&lang=ts&setup=true"

import "./transportSwitch.vue?vue&type=style&index=0&id=4ff4bfa1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ff4bfa1"]])

export default __exports__